interface ErrorStateProps {
  /** Heading shown above the error message. */
  readonly title?: string;
  /** Detailed message — usually `error.message` or a friendlier rephrase. */
  readonly message: string;
  /** Optional retry handler — renders a "Try again" button if provided. */
  readonly onRetry?: () => void;
}

/**
 * User-friendly error placeholder. Used by pages when their data fetch
 * fails. Never expose raw error objects, stack traces, or internal paths;
 * the parent should sanitize the message before passing it in.
 */
export function ErrorState({ title = 'Something went wrong', message, onRetry }: ErrorStateProps) {
  return (
    <div role="alert" className="mx-auto max-w-md rounded-md border border-rose/30 bg-rose-bg/40 p-6 text-center">
      <h2 className="mb-2 text-base font-bold text-rose">{title}</h2>
      <p className="mb-4 text-sm leading-[1.6] text-text-2">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center rounded-md border border-rose/40 bg-white px-4 py-2 text-sm font-semibold text-rose transition hover:bg-rose-bg"
        >
          Try again
        </button>
      )}
    </div>
  );
}
